import { IReward } from "api/types";
import Button from "components/common/Button/Button";
import Disabled from "components/common/Disabled";
import Text from "components/common/Text/Text";
import * as React from "react";
import { Link } from "react-router-dom";
import { Routes } from "router";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IRedeemCartSection {
  className?: string;

  rewards?: IReward[];
  pointsBalance?: number;
  total?: number;
}

const RedeemSection = styled(
  ({ className, total, rewards, pointsBalance }: IRedeemCartSection) => (
    <div className={className}>
      <TotalLabel>Total:</TotalLabel>
      <Total>{total} Points</Total>
      <Disabled isDisabled={total === 0} inline={false}>
        <Link
          to={{
            pathname: Routes.WaitForBudtener,
            state: { total, rewards, pointsBalance }
          }}
        >
          <Button fullWidth primary type="submit" disabled={total === 0}>
            Redeem Now
          </Button>
        </Link>
      </Disabled>
    </div>
  )
)`
  width: 100%;
  padding: 2rem;
  text-align: center;
  color: ${theme.color.primary};
  background-color: ${theme.color.secondary};
  border-bottom-right-radius: ${theme.global.radius};
  border-bottom-left-radius: ${theme.global.radius};
`;

const TotalLabel = styled(Text)`
  float: left;
  font-size: 18px;
  margin-bottom: 10px;
  color: ${theme.color.primary};
`;

const Total = styled(Text)`
  float: right;
  font-size: 18px;
  color: ${theme.color.primary};
`;

export default RedeemSection;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/ChooseRewards/Cart/RedeemSection.tsx